import React from "react";

import EmailSettingsPanel from "./emailsettingspanel";
import EditViewPanel from "components/panels/EditViewPanel";

interface State {
  emailProfile: server.dto.UserEmailProfile
}

class EmailSettings extends React.Component<any, State> {
  state: State = {
    emailProfile: null
  };

  componentDidMount() {
    document.title = RESX.PersonalSettings.EmailSettings;

    window.CoreApi.UserEmailProfile.GetUserEmailProfile()
      .then(profile => { this.setState({ emailProfile: profile.data?.data }); });
  }

  public render(): JSX.Element {
    return <EditViewPanel
      isLoading={this.state.emailProfile == null}
      title={RESX.PersonalSettings.EmailSettings}
    >
      {this.state.emailProfile && <EmailSettingsPanel initialEmailProfile={this.state.emailProfile} />}
    </EditViewPanel>;
  }
}

export default EmailSettings;
